import { Paper, Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { doubleToHighLow } from './DoubleToHighLow';

export function FaceResult({ model1Result, title }) {
  const { t } = useTranslation();
  const scoreItem = (heading, value) => {
    return (
      <Stack justifyContent="space-between" spacing={2} direction="row">
        <Typography>{heading}</Typography>
        <Typography>{t(value)}</Typography>
      </Stack>
    );
  };

  return (
    <>
      <Paper sx={{ padding: 2 }}>
        <Stack spacing={1}>
          <Typography variant="h6" color="primary">
            {title}
          </Typography>
          {scoreItem('Probability of facial asymentry', doubleToHighLow(model1Result.faceScore))}
          {scoreItem('Side', model1Result.faceSide)}
          {model1Result.facePalsyType ? scoreItem('Probable facial asymetry cause', model1Result.facePalsyType) : null}
        </Stack>
      </Paper>
    </>
  );
}
